// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable class-methods-use-this, jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, react/no-danger */
import React from "react"
import Close from "@kiwicom/orbit-components/lib/icons/Close"

type Props = {
  onClose: (arg1: number) => void
  bannerText: string[]
}

class AlertModal extends React.Component<Props> {
  componentDidMount() {
    // timeout animation, slide from right after mount
    setTimeout(() => {
      const AlertModalEl = document.getElementById("AlertModal")
      if (AlertModalEl) {
        AlertModalEl.classList.add("shown")
      }
    }, 1500)
  }

  render() {
    const { bannerText, onClose } = this.props
    return (
      <div id="AlertModal" className="AlertModal">
        {bannerText.map((banner, i) => (
          <div className="AlertModal-banner" key={banner}>
            <div className="AlertModal-close" onClick={() => onClose(i)}>
              <Close ariaHidden />
            </div>
            <span dangerouslySetInnerHTML={{ __html: banner }} />
          </div>
        ))}
      </div>
    )
  }
}

export default AlertModal
